/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { FunctionComponent } from "react";

import { StrapiPrivacyPage } from "@/types/strapi";

import { ColumnGaps } from "@/tokens/spacing";

import { Divider } from "@/ui/atoms/divider";
import { GridColumn } from "@/ui/atoms/grid_column";
import { GridContainer } from "@/ui/atoms/grid_container";
import { Text } from "@/ui/atoms/text";
import { PrivacyOverviewItem } from "@/ui/molecules/privacy_overview_item";

import { buildStylesByBreakpoint } from "@/util/style_util";

export const PrivacyHero: FunctionComponent<StrapiPrivacyPage> = (props) => {
    /**
     * Styles
     */
    const overviewItemsContainerStyles = css(
        { display: "flex" },
        buildStylesByBreakpoint("flexDirection", {
            extraSmall: "column",
            medium: "row",
        }),
        buildStylesByBreakpoint("gap", ColumnGaps),
    );

    const privacyHeroStyles = css({
        alignItems: "flexStart",
        display: "flex",
        flexDirection: "column",
    });

    /**
     * Rendering
     */

    const renderOverview = () => {
        const { Overview_Items } = props;

        if (!Overview_Items) {
            return;
        }
        return (
            <GridColumn className={overviewItemsContainerStyles}>
                {Overview_Items.map((_item) => (
                    <PrivacyOverviewItem
                        {..._item}
                        className={css({
                            flex: 1,
                        })}
                        Icon="Settings Gear"
                        key={`privacy-hero::overview-item::${_item.id}`}
                    />
                ))}
            </GridColumn>
        );
    };

    return (
        <GridContainer>
            <GridColumn
                className={privacyHeroStyles}
                columnSpan={6}
                marginBottom="LongformHeadlineMarginBottom"
                marginTop="Default"
            >
                <Text
                    fontSize="HeadlineDefault"
                    marginBottom="LongformHeadlineSmall"
                    marginTop="Default"
                    tag="h1"
                >
                    {props.Hero_Headline}
                </Text>

                <Text
                    fontSize="TextDefault"
                    marginBottom="LongformHeadlineLarge"
                    marginTop="LongformParagraph"
                >
                    {props.Hero_Description}
                </Text>

                <Divider span={96} />
            </GridColumn>

            {renderOverview()}
        </GridContainer>
    );
};
